<script lang="ts">
    import { goto } from "$app/navigation";
    import { modalStore, clearModal } from "$lib/stores/modalStore";

    let dialogHTML: HTMLDialogElement;

    function cancelModal() {
        dialogHTML.close();

        clearModal();
    }

    async function gotoLink() {
        const tempLink = $modalStore.link;
        clearModal();

        await goto(tempLink);
    }

    $: {
        if (typeof dialogHTML != "undefined") {
            if ($modalStore.title === "" && dialogHTML.open) {
                // console.log("closing modal");
                dialogHTML.close();
            } else if ($modalStore.title !== "" && !dialogHTML.open) {
                // console.log("opening modal");
                dialogHTML.showModal();
            }
        }        
    }
</script>

<!-- pop-up dialog box, containing a form -->
<dialog bind:this={dialogHTML} class="modal">
    <button class="cancelButton" data-testid={"modal_cancel"} type="reset" on:click={() => cancelModal()}>
        X
    </button>

    <h1 data-testid={"modal_title"}>
        {$modalStore.title}
    </h1>
    <p  data-testid={"modal_body"}>
        {@html $modalStore.body}
    </p>

    {#if $modalStore.link !== ""}
        <button class="modalButton" data-testid={"modal_link"} on:click={async () => gotoLink()}>
            {$modalStore.linkText}
        </button>
    {/if}   
</dialog>

<style>
    .modal {
        width: 60vw;
        max-width: 400px;
        height: 200px;
        border: 0;
        border-radius: 0.5em;
        overflow-y: auto;    
        overflow-x: auto;
    }

    .modalButton {
        display: block;

        padding: 12px 20px;
        width: 100%;
        margin: 0px auto;
        bottom: 10px;


        background-color: var(--primary-colour);
        border: none;
        color: #ffffff;
        
        text-align: center;
        text-decoration: none;
        font-size: 16px;
        border-radius: 10px;
    }

    .cancelButton {
        border-radius: 50%;
        padding: 0.5em;
        width: 30px;
        height: 30px;
        border: 2px solid #000000;
        color: #000000;
        position: relative;
    }

    .cancelButton:hover {
        border: 2px solid #f47c50;
        background-color: #f47c50;
        color: #ffffff;
    }    
</style>
  